<date-picker class="start-date"
             [formControl]="dateTimeForm.controls.dateFrom"
             [dateFormat]="dateFormat">
</date-picker>
<date-picker class="end-date"
             [formControl]="dateTimeForm.controls.dateTo"
             [dateFormat]="dateFormat">
</date-picker>
